import { Swiper, SwiperSlide } from 'swiper/react';
import styled from '@xstyled/styled-components';
import mapProductVariantAttributes from 'utils/mapProductVariantAttributes';
import useSelectColor from 'hooks/products/useSelectColor';
import ColorBox from './ColorBox';
import { FlexBox } from '@/UI/Primitives/FlexBox';

const SwiperContainer = styled.div`
  width: 100%;
  max-width: max-content;
  margin: 0.5rem auto 0;

  @media (min-width: desktop) {
    display: none;
  }
`;

const StyledSwiper = styled(Swiper)`
  max-width: 620px;

  .swiper-slide {
    display: block;
    width: auto;
  }
`;

export default function ColorSwiper({ variants }) {
  const { selectedColor, selectColor } = useSelectColor();

  return (
    <SwiperContainer>
      {variants.length > 5 ? (
        <StyledSwiper slidesPerView="auto" loop={true}>
          {variants.map(variant => {
            const { id, sku, image, media_gallery, color, colorUID } =
              mapProductVariantAttributes(variant);
            return (
              <SwiperSlide key={sku}>
                <ColorBox
                  image={image}
                  color={color}
                  selected={selectedColor === sku}
                  onClick={() => selectColor(id, sku, colorUID, media_gallery)}
                />
              </SwiperSlide>
            );
          })}
        </StyledSwiper>
      ) : (
        <FlexBox justify="center" spaceX="1rem">
          {variants?.map(variant => {
            const { id, sku, image, media_gallery, color, colorUID } =
              mapProductVariantAttributes(variant);
            return (
              <ColorBox
                key={sku}
                image={image}
                color={color}
                selected={selectedColor === sku}
                onClick={() => selectColor(id, sku, colorUID, media_gallery)}
              />
            );
          })}
        </FlexBox>
      )}
    </SwiperContainer>
  );
}
